import React from "react";
import { Navigate } from "react-router-dom";
// type
import { TMainPageLayoutV3 } from "../type";
import ApplicationDocumentSelector from "@/utilities/ApplicationDocumentSelector";
import EResourceType from "@/cms/enums/EResourceType";
import CoreDefault from "@/core/Defaults";
import TApplicationDocument from "@/cms/types/TApplicationDocument";


const MNPG044 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG044.rendered: ", props);

    if ( !props.params?.["contentDetails"] ) return null;

    const data = ApplicationDocumentSelector<TApplicationDocument|undefined>({
        resources: props.params["contentDetails"]?.resources,
        resourceType: EResourceType.DATA,
        type: "find"
    });

    if ( data?.filePath ) {
        window.location.href = `${CoreDefault.cdn}/${data.filePath}`;
    }

    return null;
}

const Component = React.memo(MNPG044, ( prevProps:TMainPageLayoutV3, nextProps:TMainPageLayoutV3 ) => {
    return true;
});

export default Component;
